export default {
  free_menu_items: 'Ilmainen avattu',
  discount_badge: '{{value}} alennus',
  available_at_badge: 'Saatavilla {{schedule}}',
  restricted_tooltip: 'Saatavilla {{schedule}} — vaihda noutoaika yllä tilataksesi.',
};
